// PATH: src/pages/Contact.jsx
// VERSION: 2.1 — Carga desde JSON + contactos con nombre

import React from 'react';
import {
  Box,
  Heading,
  Text,
  Link,
  VStack,
  Container,
  SimpleGrid,
  Spinner,
  Flex,
} from '@chakra-ui/react';
import data from '../data/contact.json';

import { useState } from 'react';

export default function Contact() {
  const [mapLoading, setMapLoading] = useState(true);
  return (
    <>
      <Container maxW="container.md" py={{ base: 4, md: 8 }}>
        <Heading textAlign="center" mb={6} color="text.default" size="lg">
          Contacto Directo
        </Heading>

        <Box p={6} bg="bg.card" borderRadius="lg" boxShadow="md" border="1px solid" borderColor="border.default">
          <Text mb={4}>
            Puedes ponerte en contacto con nosotros utilizando los siguientes datos:
          </Text>

          {/* Contactos con nombre y celular */}
          {data.contacts && data.contacts.length > 0 && (
            <Box mb={6}>
              <Heading as="h3" size="sm" mb={2} color="text.default">
                Contactos
              </Heading>
              <SimpleGrid
                columns={{ base: 1, md: 2 }}
                spacing={1}
              >
                {data.contacts.map((c, i) => (
                  <Text key={i}>
                    <strong>{c.name}:</strong> {c.phone}
                  </Text>
                ))}
              </SimpleGrid>
            </Box>
          )}

          {/* Otros datos de contacto (teléfonos genéricos, emails, dirección) */}
          <VStack align="start" spacing={2} mb={6}>
            {/* Fallback al arreglo phones si no existen contactos con nombre */}
            {(!data.contacts || data.contacts.length === 0) &&
              data.phones &&
              data.phones.map((p, i) => (
                <Text key={i}>
                  <strong>Teléfono:</strong> {p}
                </Text>
              ))}

            {data.emails &&
              data.emails.map((e, i) => (
                <Text key={i}>
                  <strong>Email:</strong> {e}
                </Text>
              ))}

            <Text>
              <strong>Dirección:</strong> {data.address}
            </Text>
          </VStack>

          <Box mb={4}>
            <Heading as="h3" size="md" mb={2} color="text.default">
              Ubicación en el Mapa
            </Heading>
            <Box position="relative" width="100%" height="450px" borderRadius="lg" overflow="hidden">
              {mapLoading && (
                <Flex
                  position="absolute"
                  top={0}
                  left={0}
                  right={0}
                  bottom={0}
                  align="center"
                  justify="center"
                  bg="gray.100"
                  zIndex={1}
                >
                  <Spinner size="lg" color="blue.500" />
                </Flex>
              )}
              <Box
                as="iframe"
                width="100%"
                height="100%"
                src={`https://maps.google.com/maps?q=${encodeURIComponent(
                  data.mapQuery
                )}&output=embed`}
                allowFullScreen
                loading="lazy"
                border="0"
                onLoad={() => setMapLoading(false)}
              />
            </Box>
          </Box>

          <Text mt={4}>
            También puedes visitar nuestro sitio web:{' '}
            <Link color="accent.600" href={data.website} isExternal>
              {data.website.replace('https://', '')}
            </Link>
          </Text>
        </Box>
      </Container>
    </>
  );
}
